// NATIVE 
import React from 'react';

// INSTALLED 
import { Link } from 'react-router-dom';
import { deepOrange } from '@mui/material/colors';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Box, Breadcrumbs, Button, Card, Divider, Grid, Tabs, Typography } from '@mui/material';
import { BackHand, Bloodtype, ChildFriendly, FormatAlignJustify, LocalPhone, LocationOn, MailOutline, Person, PhoneAndroid, PushPin, Security } from '@mui/icons-material';
import { DetalleBeneficiarios, DetalleContratoyFormularios, DetalleDocumentos, DetalleDotacion, DetalleEducacion, DetalleInformacionLaboral, DetallePermisos, DetalleSeguridadSocial } from '../../components/empleado/detalles';

// CUSTOM 
import { mtDividerUpTable, timeToClosedToast } from '../../commons';
import { closeSessionGlobal, formatDateToYmd, hasPemissions } from '../../commons/utils';
import { SnackAlert } from '../../components/SnackAlert';
import CustomButtonTab from '../../components/CustomButtonTab';
import MultipleSnackbars from '../../components/MultipleSnackbars';
import { storeConvertToUserSystem } from '../../store/users_permissions';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { ModalSessionExpired } from '../../components/generics/ModalSessionExpired';
import { AvatarUsuariosPermissions } from '../../components/AvatarUsuariosPermissions';





export const DetailEmployee = () => {


  // USE DISPATCH 
  const dispatch = useDispatch();


  // USE SELECTOR 
  const { employee }:any  = useSelector( (state:any) => state.employee );

  
  // USE STATE 
  const [value, setValue] = React.useState(0);
  const [percentaje_employee, setPercentajeEmployee] = React.useState(0);

 
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);


  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });


  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }


  //  FUNCTION COMPONENT 
  function CustomTabPanel(props: TabPanelProps) {

    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }



  // CONST FUNCTIONS 
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };




  const createUserSystem = async(employeeId:any) => {

   
    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'view');
      
      
    if( !havePermissions ){
      
        await validateLsPermissions('No tienes pemisos para (Crear) empleado sistema.');

        return false;                                                             
        
    }

     const response =  await dispatch( storeConvertToUserSystem(employeeId, setPercentajeEmployee) );


     const result = await validateResponseCreate(response, ' ((Crear) empleado sistema.) ');
  
    if (!result) {
        return false;
    }


    if (response.ok) {

      const message:any = {
        msg:  response.message,
        status: 'success'
      };
    
      await setMsgSnack(message);
      await setAlertSnack(true);


    }


  }



  const validateLsPermissions = async(message:string) => {
  
    const errors:any = {
      msg: message,
      status: 'error'
    };
  
    await setMsgSnack(errors);
    await setAlertSnack(true);
  
  
  }

  const validateResponseCreate = async(response:any, textActionConcat: string) => {
          
          
        if (  response.code == 401  ) {
          await localStorage.removeItem('lastSelectedQypht');
          await closeSessionGlobal();
          setModalSessionExpired(true);
          return false;
        }
  
      
        // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
        if (!response.ok && response.code == 403 ) { 
  
        
          const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
          };
        
          await setMsgSnack(errors);
          await setAlertSnack(true);
  
        
          return false;
          
        }
  
  
        // 403 EL DATO YA SE ENCUENTRA REGISTRADO
        if (!response.ok && response.code == 409 ) { 
      
          const errors:any = {
              msg: response.errors[0]+' '+textActionConcat,
              status: 'error'
          };
          
          await setMsgSnack(errors);
          await setAlertSnack(true);
  
          return false;
        }
  
        
        // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
        if (!response.ok && response.code == 400 ) { 
  
          const errors:any = [];
  
          response.errors.forEach( (element:any) => {
              
              errors.push({
                type: 'error',
                text: element
              })
          });
  
            
          setMessagesAlerts(errors);
          return false;
  
        }
  
        return true;
      
  } 

  return (
    
     <>

     <ModalSessionExpired  open={modalSessionExpired}  />
     <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
     <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
         

        <BreadCrumbsAndTitle
                    title="Detalle Empleado" 
                    mainModule="Talento Humano" 
                    parent="Detalle Empleado"
                    action="/talento-humano/empleado" />

        <Divider sx={{ marginBottom: mtDividerUpTable }}/>

        <Grid container spacing={2}>
            
            {/* INICIO LADO A */}
              <Grid item xs={3}> 
                <Card
                    sx={{
                      alignItems: 'center',
                      p: 3,
                      borderRadius: 2,
                      boxShadow: 3,
                      bgcolor: 'background.paper',
                    }}
                  >
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem', marginTop: '1rem'}}>
                    <AvatarUsuariosPermissions urlImage={employee.employee_avatar} typeImage={'image-employee'} />
                  </div>

                  <Typography  sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.10rem', marginTop: 4, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> { employee.name+' '+employee.last_name } </Typography>

                  <Typography  sx={{ textAlign: 'center',  fontSize: '0.9rem',  textTransform: 'capitalize' }}> { employee.position.name }  </Typography>

                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 4, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> <LocationOn fontSize='small' sx={{ marginRight: 1 }} /> { employee.address} </Typography>
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <PushPin fontSize='small' sx={{ marginRight: 1 }} /> { employee.neighborhood} </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400, wordBreak: 'break-word' }}> <MailOutline fontSize='small' sx={{ marginRight: 1 }} /> { employee.email} </Typography>
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <LocalPhone fontSize='small' sx={{ marginRight: 1 }} /> { employee.landline } </Typography>
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <PhoneAndroid fontSize='small' sx={{ marginRight: 1 }} /> { employee.cell_phone } </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <ChildFriendly fontSize='small' sx={{ marginRight: 1 }} /> { formatDateToYmd(employee.birthdate) } </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <Bloodtype fontSize='small' sx={{ marginRight: 1 }} /> RH: { employee.rh } </Typography> 
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <BackHand fontSize='small' sx={{ marginRight: 1 }} /> Dominación: { employee.dominance } </Typography>     
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <FormatAlignJustify fontSize='small' sx={{ marginRight: 1 }} /> Estrato: { employee.stratum } </Typography>    
                  <Typography display="flex" alignItems="center"  sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: '', fontSynthesisWeight: 400,wordBreak: 'break-word' }}> <Person fontSize='small' sx={{ marginRight: 1 }} /> Tipo contrato: { employee.type_contract } </Typography>    
                  
                  <Divider/>

                  <Button
                    sx={{ margin: 2 }}
                    variant="contained"
                    onClick={ () => createUserSystem(employee.id) }
                    color="primary">
                    Crear Como Usuario Sistema
                  </Button>


                </Card>
              </Grid>
            {/* FIN LADO A  */}





            {/* INICIO LADO B */}
            <Grid item xs={9}> 

              <Box sx={{ width: '100%' }}>
                {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}> */}
                <Box>
                  <Tabs variant='scrollable'
                        scrollButtons="auto"
                        allowScrollButtonsMobile 
                        TabIndicatorProps={{
                          style: { display: 'none' },
                        }} 
                        TabScrollButtonProps={{
                          sx: {
                           
                            width: 40, // Cambia el ancho del botón
                            height: 40, // Cambia el alto del botón
                            "& svg": { fontSize: 30 }, // Ajusta el tamaño del ícono dentro del botón
                          }
                        }}
                        selectionFollowsFocus={true} value={value} onChange={handleChange} aria-label="tabs detalle clientes">
                        {/* <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Permisos" {...a11yProps(0)} /> */}
                        <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Informacion laboral" {...a11yProps(0)} />
                        <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Educacion" {...a11yProps(1)} />
                        <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Seguridad social" {...a11yProps(2)} />
                        <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Documentos" {...a11yProps(3)} />
                        <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Beneficiarios" {...a11yProps(4)} />
                        <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Dotacion" {...a11yProps(5)} />
                        <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Contrato y formularios" {...a11yProps(6)} />
                  </Tabs> 
                </Box>
              </Box>

              <Card
                  sx={{
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                  }}
                >


                <CustomTabPanel value={value} index={0}>
                    {/* <DetallePermisos /> */}
                    <DetalleInformacionLaboral />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <DetalleEducacion/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <DetalleSeguridadSocial />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                  <DetalleDocumentos />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4}>
                  <DetalleBeneficiarios />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={5}>
                  <DetalleDotacion />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={6}>
                  <DetalleContratoyFormularios />
                </CustomTabPanel>

              </Card>
            </Grid>
            {/* FIN LADO B  */}

            
        </Grid>
     </>
  )
}
